import { dictionary } from './dictionary';

export const item = {
    dictionary,
};
